import CONFIG from "./config";

export async function fetchTTS(message, voiceName) {
  try {
    const response = await fetch(
      `${CONFIG.API_BASE_URL}/api/Tts?message=${encodeURIComponent(message)}&voiceName=${voiceName}`
    );
    if (!response.ok) throw new Error(await response.text());
    const blob = await response.blob();
    return URL.createObjectURL(blob);
  } catch (err) {
    console.error("TTS fetch error", err);
    return null;
  }
}